import React from 'react';

import DeleteComponent from 'components/ImageUploadPreview/DeleteComponent';
import ImagePreviewComponent from 'components/ImageUploadPreview/ImagePreviewComponent';
import { Preview, ImagePreview, OverlayContainer } from 'components/ImageUploadPreview/styles';
import styled from 'styled-components';

import { isPdfType, getFileNameFromUrl } from 'constants/helper';

import { FileCardComp } from 'uiToolkit/FileCardComp';

export default function MediaPreview({ className, fileUrl, deleteFile, uploading, uploadFile, setGif, gifUrl }) {
  let fileName = '';
  if (isPdfType(fileUrl)) {
    fileName = getFileNameFromUrl(fileUrl);
    return (
      <Container padding="1rem">
        <Preview>
          <FileCardComp fileName={fileName} title={fileName} downloadLink={fileUrl} fullWidth />
          <OverlayContainer>
            <DeleteComponent deleteImage={deleteFile} />
          </OverlayContainer>
        </Preview>
      </Container>
    );
  }
  return (
    <Container>
      <ImagePreviewComponent
        fileUrl={fileUrl}
        deleteFile={deleteFile}
        uploading={uploading}
        uploadedFile={uploadFile}
      />
      {gifUrl && (
        <Preview>
          <ImagePreview src={gifUrl} isUploaded />
          <OverlayContainer>
            <DeleteComponent deleteImage={() => setGif(null)} />
          </OverlayContainer>
        </Preview>
      )}
    </Container>
  );
}

const Container = styled.div`
  padding: ${(props) => (props.padding ? props.padding : '0')};
`;
